
// @module ContactUs
define(
    'ContactUs.View'
    ,	[
        	'Backbone'
        ,	'Backbone.FormView'
        ,	'ContactUs.Model'
        ,	'contact_us.tpl'
    ]
    ,	function(
        Backbone
        ,	BackboneFormView
        ,	ContactUsModel
        ,	contact_us_tpl
    )
    {
        'use strict';

    // @class ContactUs.View @extends Backbone.View
    return Backbone.View.extend({

      template: contact_us_tpl

        ,   events: {
            'click [data-action="submit-contact-us"]': 'submitContactUs'
        }

        ,	bindings: {
                '[name="reason"]': 'reason',
                '[name="name"]': 'name',
                '[name="email"]': 'email',
                '[name="message"]': 'message',
                '[name="order_number"]': 'order_number'
            }

      ,	initialize: function (options)
      {
        this.application = options.application;
        this.model = new ContactUsModel;
        this.customLists = {}
        BackboneFormView.add(this, { noCloneModel: true });

        // go retrieve list information
        this.getListOptions()
      }

      /**
       * retrieve list options to render onto the page to the user for certain select fields
       */
      , getListOptions: function()
      {
        var self = this;

        // get list data to render onto form
        $.get('/app/site/hosting/scriptlet.nl?script=405&deploy=1&compid=776636&h=ff67724a603bdc11c3b6&site=llt&ns-at=AAEJ7tMQP1tpbGY9knZ6lKRqs_vriudMREhg0FbYx3MRVaubJoQ', {}, function(resp){

          // update the global variable with the new reasons list. Will re-render the page after retrieving
          self.customLists.reasons = resp['reasons']

          // re-render the page and toggle the form lock so the user can't modify the form
          self.render()

          // default selection once page is rendered with the new select options
          jQuery('#reason').val('').trigger('change')
        }, 'json')
      }


      /**
       * main function called when the user submits the form
       * @param e
       */
      ,	submitContactUs: function (e)
      {
        this.toggleFormLock(true);
        e.preventDefault();

        // Run front end validation one last time
        this.model.validate();

        // If the model is valid then we save it, otherwise if validation fails unlock form
        if (this.model.isValid()) this.sendRequest();
        else this.toggleFormLock(false);
      }


      /**
       * this will handle sending the form data to the service. the service will send an email to the appropriate
       * endpoints and will handle the building and content of the email itself.
       */
      , sendRequest: function(){
        var self = this;

        // call backend service call that will create the case record
        this.model.save(_.clone(this.model.attributes))
          .done(function(resp) {
            // console.log('sendRequest.done()', resp)
            // sets toggle to display the message
            self.displayConfirmationMessage = true;

            // re-render the page and toggle the form lock so the user can't modify the form
            self.render();
            self.toggleFormLock(true);
          });
      }

      /**
       * little re-usable function that simply handles locking and unlocking the form. better user experience.
       * @param disable
       */
      , toggleFormLock: function(disable){
        // disable all of the fields for kicks
        jQuery('[name="submit_button"]').attr("disabled", disable);
        jQuery('[name="reason"]').prop("disabled", disable);
        jQuery('[name="name"]').prop("disabled", disable);
        jQuery('[name="email"]').prop('disabled', disable);
        jQuery('[name="message"]').prop('disabled', disable);
        jQuery('[name="order_number"]').prop('disabled', disable);
      }

      // @method getContext
      // @return {ContactUs.View.Context}
      ,	getContext: function()
      {
        // @class ContactUs.View.Context
        return {
          displayConfirmationMessage: this.displayConfirmationMessage,
          reasonOptions: this.customLists.reasons
        };
        // @class ContactUs.View
      }
    });
  });

